export const EXTENSION_PATTERN = /(^\w+\/)/;
